import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertDescription } from '../alert';
import { Button } from '../button';
import { Card, CardContent, CardHeader, CardTitle } from '../card';
export function AuthGuard({ isAuthenticated, isLoading = false, requiredRoles = [], userRoles = [], requiredPermissions = [], userPermissions = [], children, fallback, onLogin, redirectToLogin = false }) {
    // Show loading state
    if (isLoading) {
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen", children: _jsx("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" }) }));
    }
    // Not authenticated
    if (!isAuthenticated) {
        if (fallback) {
            return _jsx(_Fragment, { children: fallback });
        }
        return (_jsx("div", { className: "flex items-center justify-center min-h-screen p-4", children: _jsxs(Card, { className: "w-full max-w-md", children: [_jsx(CardHeader, { className: "text-center", children: _jsx(CardTitle, { children: "Authentication Required" }) }), _jsxs(CardContent, { className: "space-y-4", children: [_jsx(Alert, { children: _jsx(AlertDescription, { children: "You need to be logged in to access this page." }) }), onLogin && (_jsx(Button, { onClick: onLogin, className: "w-full", children: "Sign In" }))] })] }) }));
    }
    // Check role requirements
    if (requiredRoles.length > 0) {
        const hasRequiredRole = requiredRoles.some(role => userRoles.includes(role));
        if (!hasRequiredRole) {
            if (fallback) {
                return _jsx(_Fragment, { children: fallback });
            }
            return (_jsx("div", { className: "flex items-center justify-center min-h-screen p-4", children: _jsxs(Card, { className: "w-full max-w-md", children: [_jsx(CardHeader, { className: "text-center", children: _jsx(CardTitle, { children: "Access Denied" }) }), _jsx(CardContent, { children: _jsx(Alert, { variant: "destructive", children: _jsxs(AlertDescription, { children: ["You don't have the required permissions to access this page. Required roles: ", requiredRoles.join(', ')] }) }) })] }) }));
        }
    }
    // Check permission requirements
    if (requiredPermissions.length > 0) {
        const hasRequiredPermission = requiredPermissions.some(permission => userPermissions.includes(permission));
        if (!hasRequiredPermission) {
            if (fallback) {
                return _jsx(_Fragment, { children: fallback });
            }
            return (_jsx("div", { className: "flex items-center justify-center min-h-screen p-4", children: _jsxs(Card, { className: "w-full max-w-md", children: [_jsx(CardHeader, { className: "text-center", children: _jsx(CardTitle, { children: "Access Denied" }) }), _jsx(CardContent, { children: _jsx(Alert, { variant: "destructive", children: _jsxs(AlertDescription, { children: ["You don't have the required permissions to access this page. Required permissions: ", requiredPermissions.join(', ')] }) }) })] }) }));
        }
    }
    // All checks passed, render children
    return _jsx(_Fragment, { children: children });
}
